import React from "react";

import BannerComponent from "./BannerComponent";
import CategoryComponent from "./CategoryComponent";
import CommunityComponent from "./CommunityComponent";
import EventComponent from "./EventComponent";
import FeaturedComponent from "./FeaturedComponent";
import GalleryComponent from "./GalleryComponent";
import InstructorComponent from "./InstructorComponent";
import RankingComponent from "./RankingComponent";
import ReviewComponent from "./ReviewComponent";
import ShortcutComponent from "./ShortcutComponent";
import TourComponent from "./TourComponent";

import type { CmsComponentProps } from "./types";
import type { HomeComponentType } from "utils/type/home";

export const CMS_COMPONENT_MAP: Record<HomeComponentType, React.FC<CmsComponentProps>> = {
  banner: BannerComponent,
  featured: FeaturedComponent,
  category: CategoryComponent,
  shortcut: ShortcutComponent,
  card: EventComponent,
  review: ReviewComponent,
  ranking: RankingComponent,
  instructor: InstructorComponent,
  tour: TourComponent,
  gallery: GalleryComponent,
  community: CommunityComponent,
};

export { BannerComponent, FeaturedComponent, CategoryComponent, ShortcutComponent, EventComponent, ReviewComponent, RankingComponent, InstructorComponent, TourComponent, GalleryComponent, CommunityComponent };
